import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import * as RequestActions from '../../../actions/requestActions';
import Plans from '../../../constatns/plans';
import ImageLeft from '../../custom/sections/ImageLeft';
import SelectableImageRight from '../../custom/sections/SelectableImageRight';
import './index.css';


class WebApi extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }


  render() {
    const { lang } = this.props;

    return (
      <div className='page-padding'>
        <ImageLeft lang={lang} content={Plans.leftImage}/>
        <SelectableImageRight lang={lang} content={Plans.selectableImage}/>
        <ImageLeft lang={lang} content={Plans.leftImage}/>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  lang: state.request.lang
});


const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    ...RequestActions,
  }, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(WebApi);
